<div class="rank-selector">
  <button
    [disabled]="isDisabled"
    [matTooltipDisabled]="isDisabled"
    type="button"
    class="rank-button"
    mat-stroked-button
    matTooltip="{{ (allowEmpty ? 'map.sidebar.psa.rank_from_one' : 'map.sidebar.psa.rank') | translate }}"
    (click)="incrementRank()"
  >
    {{ valueRank ?? '–' }} / 5
  </button>
</div>
